import { PathRoute } from '@/domains/routes/route.entity';
import { IconType, type NavbarLinkProps } from '../models/navbar.model';

export const navbarLinks: NavbarLinkProps[] = [
  {
    key: 'inicio',
    label: 'Inicio',
    path: PathRoute.HOME,
  },
  {
    key: 'estudiantes',
    label: 'Estudiantes',
    path: PathRoute.ESTUDIANTE,
  },
  {
    key: 'riesgoAcademico',
    label: 'Riesgo académico',
    path: PathRoute.RIESGO_ACADEMICO,
  },
];

export const profileMenu: NavbarLinkProps[] = [
  {
    key: 'usuario',
    label: 'Usuarios',
    icon: IconType.USER,
  },
  {
    key: 'tipos-acciones',
    label: 'Tipos de Acciones',
    icon: IconType.ACTION_TYPE,
  },
  {
    key: 'mensajes',
    label: 'Mensajes',
    icon: IconType.MESSAGE,
  },
  {
    key: 'cerrar-sesion',
    label: 'Cerrar sesión',
    icon: IconType.LOGOUT,
  },
];
